export enum ModalType {
	ProductDetails = "ProductDetails",
	Auth = "Auth",
	ProductIdea = "ProductIdea",
	GrowWithUs = "GrowWithUs",
	ContactUs = "ContactUs",
	UpdateProfile = "UpdateProfile",
	CreatePost = "CreatePost",
	VIP = "VIP",
}
